import script from "./PreSportFeaturedFixtures.vue?vue&type=script&setup=true&lang=js"
export * from "./PreSportFeaturedFixtures.vue?vue&type=script&setup=true&lang=js"

import "./PreSportFeaturedFixtures.vue?vue&type=style&index=0&id=14f04e3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14f04e3e"]])

export default __exports__